(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["t340-lens-scroll"] && !Shopify.designMode) return;
  try {
    const t340Clamp01 = (value) => Math.max(0, Math.min(1, value))

  const t340Ease = (value) => {
    const clamped = t340Clamp01(value)
    return clamped * clamped * (3 - 2 * clamped)
  }

  // Every progress window in this story derives from these five numbers. They
  // used to be scattered as literals across t340BuildTimeline, t340CopyMotion
  // and t340SceneMotion, which meant a retune had to be applied by hand in
  // three places or the title's fade would drift out of step with its own beat.
  //
  // Retuned 2026-07-25 after measuring the rendered track (4,365px for four
  // lenses at a 900px viewport). The opening owned 0 -> 0.315 = 1,375px, over a
  // screen and a half of scrolling for two lines of type, while each lens was
  // actually settled for only 0.100 (437px) and spent 0.090 (393px) crossfading
  // — a hold-to-transition ratio of 1.1:1, which is why no lens ever felt like
  // it had landed. Compressing the opening and halving the crossfade moves that
  // to about 2.9:1 without touching the track length: the time comes out of the
  // hand-off and goes into the product.
  // A beat needs three parts: arriving, held, leaving. Express the first and
  // last as fractions of the beat so a retune cannot accidentally leave a line
  // of type with no plateau — the first cut of this retune gave the manifesto a
  // 0.055 beat and a 0.055 arrival ramp, so it reached full strength on exactly
  // the frame it began leaving and never actually landed.
  const T340_TIMING = {
    overviewTitle: { start: 0.010, end: 0.050 },
    overviewManifesto: { start: 0.078, end: 0.158 },
    firstBeat: 0.190,
    lastBeat: 0.985,
    transition: 0.055,
    arrivalFraction: 0.55,
    departureFraction: 0.82,
    // How early a beat's copy starts leaving, as a fraction of its own beat.
    exitOverlapFraction: 0.25,
    // How early the annotation leads its beat, as a fraction of the gap it has
    // to clear. Both must stay under 0.5 or the annotation starts before the
    // hand-off into its beat is half done. See t340SceneMotion.
    infoLeadFraction: 0.4,
    specsLeadFraction: 0.25,
    // Reveal durations for the scene annotation. Deliberately ABSOLUTE, not
    // fractions of the crossfade: how fast a spec block fades up is a different
    // quantity from how wide a hand-off is, and tying them together would change
    // the annotation's speed every time the pacing is retuned. They live here so
    // they are visible and covered by the no-bare-literals guard.
    infoRamp: 0.045,
    specsRamp: 0.05,
    // The opening title's reveal window on the `entry` axis (see t340CopyMotion).
    // A different axis from progress, but still a timing window: `start` is where
    // on that axis the reveal opens and `span` is how much of it the reveal takes.
    entryReveal: { start: 0.4, span: 0.5 },
    // How far away, in STAGE-DISTANCE units, a scene's copy is still visible: it
    // begins showing 18% into the hand-off and fades over the remaining 82%.
    // A window on the stage axis rather than on progress — a different axis, but
    // a window all the same, so it belongs here and not in a "non-timing" list.
    // Deliberately a SEPARATE knob from departureFraction: the two happen to
    // share a value today and must stay independently tunable.
    stageFadeSpan: 0.82
  }

  // Frame-loop smoothing. Separate from the story beats on purpose: these govern
  // how the scroll position is chased, not where anything sits on the timeline,
  // and retuning the pacing must never drag them along. Both are still quantities
  // on a time/progress axis, so neither is a "non-timing" literal.
  const T340_SMOOTHING = {
    // Assumed frame duration, in ms, before a real delta is available.
    frameMs: 16.67,
    // Dead band around the target, in progress units: inside it, snap and stop
    // queueing frames.
    snapEpsilon: 0.00008
  }

  const t340BuildTimeline = (lensCount) => {
    const timeline = [
      { start: T340_TIMING.overviewTitle.start, end: T340_TIMING.overviewTitle.end },
      { start: T340_TIMING.overviewManifesto.start, end: T340_TIMING.overviewManifesto.end }
    ]
    const count = Math.max(0, Number(lensCount) || 0)
    const beatCount = count
    const firstBeat = T340_TIMING.firstBeat
    const lastBeat = T340_TIMING.lastBeat
    const transition = beatCount > 1 ? T340_TIMING.transition : 0
    const hold = (lastBeat - firstBeat - transition * Math.max(0, beatCount - 1)) / Math.max(1, beatCount)
    let cursor = firstBeat
    for (let index = 0; index < beatCount; index += 1) {
      timeline.push({ start: cursor, end: cursor + hold })
      cursor += hold + transition
    }
    return timeline
  }

  const t340StageForProgress = (progress, timeline) => {
    if (progress <= timeline[0].end) return 0
    for (let index = 1; index < timeline.length; index += 1) {
      const previous = timeline[index - 1]
      const current = timeline[index]
      if (progress < current.start) {
        const transitionProgress = (progress - previous.end) / Math.max(0.001, current.start - previous.end)
        return index - 1 + t340Clamp01(transitionProgress)
      }
      if (progress <= current.end) return index
    }
    return timeline.length - 1
  }

  // `entry` is how far the track has travelled toward its pin: 0 when its top
  // edge is at the fold, 1 once it is pinned. Progress is still 0 for all of
  // that, so anything keyed to progress cannot animate while the opening is
  // actually arriving on screen. Defaults to 1 so callers that only care about
  // pinned behaviour see the settled state.
  const t340CopyMotion = ({ progress, stage, sceneIndex, mobile, timeline, entry = 1 }) => {
    let opacity
    let offset
    let scale

    const title = T340_TIMING.overviewTitle
    const manifesto = T340_TIMING.overviewManifesto

    if (sceneIndex === 0) {
      const settle = t340Ease((progress - title.start) / (title.end - title.start))
      // Leaves just before its own beat closes and is gone by the time the
      // manifesto opens, so the two never overlap. The pre-roll is a fraction of
      // the title's own beat rather than a bare 0.01, so retuning the opening
      // cannot leave it at the wrong scale.
      const titlePreRoll = (title.end - title.start) * T340_TIMING.exitOverlapFraction
      const departure = t340Ease((progress - (title.end - titlePreRoll)) / ((manifesto.start - title.end) + titlePreRoll))
      // Arrives dim and brightens as the reader scrolls it into place, so the
      // reveal is driven by the hand rather than by a clock the reader cannot
      // see. A timed fade here always finished over the empty band above the
      // title and was invisible in practice.
      const rise = t340Ease((entry - T340_TIMING.entryReveal.start) / T340_TIMING.entryReveal.span)
      opacity = (0.26 + 0.74 * rise) * (1 - departure)
      offset = (1 - rise) * 18
      scale = 1 + settle * 0.014 + departure * (mobile ? 0.16 : 0.34)
    } else if (sceneIndex === 1) {
      const manifestoSpan = manifesto.end - manifesto.start
      // Lands inside its own beat and then holds, rather than peaking on the
      // frame it starts to leave.
      const arrival = t340Ease((progress - manifesto.start) / (manifestoSpan * T340_TIMING.arrivalFraction))
      // Hands off to the first lens: leaves late in its beat and is gone by the
      // time that lens is due.
      const departureStart = manifesto.start + manifestoSpan * T340_TIMING.departureFraction
      const departure = 1 - t340Ease((progress - departureStart) / (T340_TIMING.firstBeat - departureStart))
      const drift = t340Clamp01((progress - manifesto.start) / manifestoSpan)
      opacity = arrival * departure
      offset = (1 - arrival) * 26 - (1 - departure) * 14 + (0.5 - drift) * 9
      scale = 0.965 + arrival * 0.035
    } else {
      const distance = Math.abs(stage - sceneIndex)
      const beat = timeline?.[sceneIndex]
      const drift = beat
        ? t340Clamp01((progress - beat.start) / Math.max(0.001, beat.end - beat.start))
        : 0.5
      opacity = t340Ease((T340_TIMING.stageFadeSpan - distance) / T340_TIMING.stageFadeSpan)
      offset = Math.max(-34, Math.min(34, (sceneIndex - stage) * 26)) + (0.5 - drift) * 8
      scale = 1 - Math.min(0.025, distance * 0.018)
    }

    return {
      opacity,
      offset,
      scale,
      nearDistance: Math.abs(stage - sceneIndex)
    }
  }

  const t340SceneMotion = ({ progress, stage, sceneIndex, timeline }) => {
    const beats = Array.isArray(timeline) ? timeline : []
    // A scene index with no beat behind it can only come from a DOM/JS desync:
    // `data-lens-count` builds the timeline, but the indices come from each
    // scene's own `data-t340ls-scene`, so the two can in principle disagree.
    // Degrade to the LAST real beat rather than to an invented window — the
    // fallback then uses timing that exists instead of two bare literals.
    const beat = beats[sceneIndex] ?? beats[beats.length - 1]
    const beatStart = beat ? beat.start : T340_TIMING.firstBeat
    const beatEnd = beat ? beat.end : T340_TIMING.lastBeat
    const arrival = t340Ease(stage - (sceneIndex - 1))
    const departure = 1 - t340Ease(stage - sceneIndex)
    let presence = arrival
    // Ghost-in starts halfway through the title beat and is fully up by the time
    // the manifesto opens, so it tracks the opening however that is retuned.
    const ghostStart = T340_TIMING.overviewTitle.start
      + (T340_TIMING.overviewTitle.end - T340_TIMING.overviewTitle.start) / 2
    const ghostSpan = Math.max(0.001, T340_TIMING.overviewManifesto.start - ghostStart)
    if (sceneIndex === 2) {
      // The title screen stays clean black so the type carries it; the scene
      // only washes in under the manifesto.
      const ghost = t340Ease((progress - ghostStart) / ghostSpan) * 0.34
      presence = Math.max(arrival, ghost)
    }
    const opacity = presence * departure
    // The zoom leads its beat by exactly one crossfade, so the incoming frame is
    // already moving as the outgoing one leaves.
    const kbLead = T340_TIMING.transition
    const kbStart = sceneIndex === 2 ? ghostStart : beatStart - kbLead
    const kenburns = t340Ease(t340Clamp01((progress - kbStart) / Math.max(0.001, beatEnd + kbLead - kbStart)))
    const scale = 1.07 - kenburns * 0.07
    const entrancePan = sceneIndex === 2 ? 0 : (1 - arrival) * 2.6
    const pan = entrancePan - (1 - departure) * 2.6
    // The annotation leads its beat, but must not start before the hand-off into
    // that beat is past its midpoint, or the incoming spec block bleeds over the
    // outgoing scene.
    //
    // Derived from the gap ACTUALLY preceding this beat, not from
    // T340_TIMING.transition. Those are not the same number for the first lens:
    // lens-to-lens hand-offs are one crossfade wide (0.055), but the gap from the
    // manifesto into lens 1 is only 0.032, so a lead of transition*0.4 = 0.022
    // exceeded that gap's half-width of 0.016 and the first lens's annotation
    // appeared before its hand-off was half done. Reading the gap per beat makes
    // the midpoint guarantee hold at every hand-off, including the opening one.
    const prevBeat = beats[sceneIndex - 1]
    const gapBefore = beat && prevBeat
      ? Math.max(0, beat.start - prevBeat.end)
      : T340_TIMING.transition
    const infoLead = gapBefore * T340_TIMING.infoLeadFraction
    const specsLead = gapBefore * T340_TIMING.specsLeadFraction
    const info = t340Ease((progress - (beatStart - infoLead)) / T340_TIMING.infoRamp) * departure
    const draw = info
    const lineOpacity = info
    const specs = t340Ease((progress - (beatStart - specsLead)) / T340_TIMING.specsRamp)
    const rangeDistance = stage < sceneIndex
      ? Math.max(0, sceneIndex - stage - 1)
      : Math.max(0, stage - sceneIndex)
    const preNear = sceneIndex === 2 && progress >= ghostStart && stage < sceneIndex

    return {
      opacity,
      scale,
      pan,
      draw,
      info,
      lineOpacity,
      specs,
      nearDistance: preNear ? 0 : rangeDistance
    }
  }

  const t340SmoothProgress = ({ current, target, deltaMs, responseMs, snap }) => {
    if (!Number.isFinite(current) || snap) return target
    const elapsed = Math.max(8, Math.min(64, Number(deltaMs) || T340_SMOOTHING.frameMs))
    const alpha = 1 - Math.exp(-elapsed / Math.max(1, responseMs))
    const next = current + (target - current) * alpha
    return Math.abs(target - next) <= T340_SMOOTHING.snapEpsilon ? target : next
  }


  if ('customElements' in window && !customElements.get('t340-lens-scroll')) {
    class T340LensScroll extends HTMLElement {
      connectedCallback() {
        if (this.initialized) {
          this.listenForModeChanges(true)
          this.syncMode()
          return
        }
        this.initialized = true
        this.track = this.querySelector('.t340ls__track')
        this.sticky = this.querySelector('.t340ls__sticky')
        this.copyScenes = [...this.querySelectorAll('[data-t340ls-copy-scene]')]
          .filter((scene) => Number(scene.dataset.t340lsCopyScene) <= 1)
        this.bgScenes = [...this.querySelectorAll('[data-t340ls-scene]')]
        this.lensImages = [...this.querySelectorAll('[data-t340ls-scene] img')]
        this.lensCount = Number(this.dataset.lensCount)
        this.storyRoot = this.closest('.t3s-protection')
        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)')
        this.shortLandscapeQuery = window.matchMedia('(max-height: 559px) and (orientation: landscape)')
        this.mobileQuery = window.matchMedia('(max-width: 749px)')
        this.timeline = t340BuildTimeline(this.lensCount)
        this.sceneDirty = true
        this.frame = 0
        this.sceneGeometryFrame = 0
        this.displayProgress = null
        this.lastFrameTime = 0
        this.snapNextFrame = true
        this.lastMobile = this.mobileQuery.matches
        this.viewportWidth = window.innerWidth
        this.preparedImages = new Set()
        this.near = true
        this.enhanced = false
        this.queue = this.queue.bind(this)
        this.render = this.render.bind(this)
        this.handleResize = this.handleResize.bind(this)
        this.handleImageLoad = this.handleImageLoad.bind(this)
        this.handleVisibilityChange = this.handleVisibilityChange.bind(this)
        this.syncMode = this.syncMode.bind(this)

        const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection
        const constrainedDevice = Boolean(
          connection?.saveData
          || (navigator.deviceMemory && navigator.deviceMemory <= 2)
          || (navigator.hardwareConcurrency && navigator.hardwareConcurrency <= 2)
        )
        const enhancementSupported = CSS.supports('position', 'sticky') && CSS.supports('overflow', 'clip')
        if (constrainedDevice || !enhancementSupported) return

        this.listenForModeChanges(true)
        this.syncMode()
      }

      disconnectedCallback() {
        this.listenForModeChanges(false)
        this.disableEnhancedMode()
      }

      listenForModeChanges(shouldListen) {
        for (const query of [this.motionQuery, this.shortLandscapeQuery]) {
          if (shouldListen) {
            if (query.addEventListener) query.addEventListener('change', this.syncMode)
            else query.addListener?.(this.syncMode)
          } else if (query.removeEventListener) {
            query.removeEventListener('change', this.syncMode)
          } else {
            query.removeListener?.(this.syncMode)
          }
        }
      }

      syncMode() {
        if (this.motionQuery.matches || this.shortLandscapeQuery.matches) {
          this.disableEnhancedMode()
        } else {
          this.enableEnhancedMode()
        }
      }

      enableEnhancedMode() {
        if (this.enhanced) return
        this.enhanced = true
        const supportsIntersectionObserver = 'IntersectionObserver' in window
        this.near = !supportsIntersectionObserver
        this.sceneDirty = true
        this.displayProgress = null
        this.lastFrameTime = 0
        this.snapNextFrame = true
        this.lastMobile = this.mobileQuery.matches
        this.viewportWidth = window.innerWidth
        this.classList.add('t340ls--ready')
        this.storyRoot?.classList.add('t3s-protection--lens-scroll')
        window.addEventListener('scroll', this.queue, { passive: true })
        window.addEventListener('resize', this.handleResize, { passive: true })
        document.addEventListener('visibilitychange', this.handleVisibilityChange)
        this.lensImages.forEach((image) => image.addEventListener('load', this.handleImageLoad))

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(this.handleResize)
          this.resizeObserver.observe(this.track)
        }


        if (supportsIntersectionObserver) {
          this.intersectionObserver = new IntersectionObserver(
            (entries) => {
              this.near = Boolean(entries[0]?.isIntersecting)
              if (this.near) {
                this.snapNextFrame = this.displayProgress === null
                this.queue()
              } else {
                this.stopFrames(true)
                this.releaseLayers()
              }
            },
            { rootMargin: '150% 0px 150%' }
          )
          this.intersectionObserver.observe(this)
        }

        if (this.near) this.queue()
      }

      disableEnhancedMode() {
        if (!this.enhanced) return
        this.enhanced = false
        window.removeEventListener('scroll', this.queue)
        window.removeEventListener('resize', this.handleResize)
        document.removeEventListener('visibilitychange', this.handleVisibilityChange)
        this.lensImages.forEach((image) => image.removeEventListener('load', this.handleImageLoad))
        this.resizeObserver?.disconnect()
        this.intersectionObserver?.disconnect()
        this.resizeObserver = undefined
        this.intersectionObserver = undefined
        this.stopFrames(true)
        this.sceneDirty = true
        this.classList.remove('t340ls--ready')
        this.storyRoot?.classList.remove('t3s-protection--lens-scroll')
        this.copyScenes.forEach((scene) => {
          scene.removeAttribute('data-t340ls-near')
          scene.style.removeProperty('--t340ls-copy-opacity')
          scene.style.removeProperty('--t340ls-copy-y')
          scene.style.removeProperty('--t340ls-copy-scale')
        })
        this.bgScenes.forEach((scene) => {
          scene.removeAttribute('data-t340ls-near')
          scene.removeAttribute('data-t340ls-scene-geometry-ready')
          scene.style.removeProperty('--t340ls-scene-bg-opacity')
          scene.style.removeProperty('--t340ls-scene-bg-scale')
          scene.style.removeProperty('--t340ls-scene-bg-x')
          scene.style.removeProperty('--t340ls-scene-draw')
          scene.style.removeProperty('--t340ls-scene-length')
          scene.style.removeProperty('--t340ls-scene-callout-opacity')
          scene.style.removeProperty('--t340ls-scene-info')
          scene.style.removeProperty('--t340ls-scene-specs')
          const svg = scene.querySelector('.t340ls__scene-callout')
          svg?.removeAttribute('viewBox')
          svg?.querySelector('path')?.removeAttribute('d')
          const info = scene.querySelector('.t340ls__scene-info')
          if (info) {
            info.style.removeProperty('left')
            info.style.removeProperty('right')
            info.style.removeProperty('top')
            info.style.removeProperty('bottom')
          }
        })
      }

      handleResize() {
        const mobile = this.mobileQuery.matches
        const width = window.innerWidth
        const majorWidthChange = Math.abs(width - this.viewportWidth) >= Math.max(96, this.viewportWidth * 0.15)
        this.sceneDirty = true
        if (mobile !== this.lastMobile || majorWidthChange) this.snapNextFrame = true
        this.lastMobile = mobile
        this.viewportWidth = width
        this.queue()
      }

      handleImageLoad() {
        this.sceneDirty = true
        this.queue()
      }

      handleVisibilityChange() {
        if (document.hidden) {
          this.stopFrames(true)
        } else {
          this.snapNextFrame = true
          this.queue()
        }
      }

      stageForProgress(progress) {
        return t340StageForProgress(progress, this.timeline)
      }

      stopFrames(resetProgress = false) {
        if (this.frame) cancelAnimationFrame(this.frame)
        if (this.sceneGeometryFrame) cancelAnimationFrame(this.sceneGeometryFrame)
        this.frame = 0
        this.sceneGeometryFrame = 0
        this.lastFrameTime = 0
        if (resetProgress) {
          this.displayProgress = null
          this.snapNextFrame = true
        }
      }

      prepareImage(image) {
        if (!image || this.preparedImages.has(image)) return
        this.preparedImages.add(image)
        image.loading = 'eager'
        const decode = image.decode ? image.decode() : Promise.resolve()
        Promise.resolve(decode).catch(() => undefined).finally(() => {
          this.sceneDirty = true
          this.queue()
        })
      }

      prepareImagesForStage(stage, direction) {
        if (!this.bgScenes.length) return
        const stageIndex = Math.max(0, Math.round(Math.max(2, stage)) - 2)
        const currentIndex = Math.min(this.bgScenes.length - 1, stageIndex)
        const adjacentIndex = currentIndex + (direction < 0 ? -1 : 1)
        this.prepareImage(this.bgScenes[currentIndex]?.querySelector('img'))
        this.prepareImage(this.bgScenes[adjacentIndex]?.querySelector('img'))
      }

      queue() {
        if (!this.enhanced || !this.near || document.hidden || this.frame) return
        this.frame = requestAnimationFrame(this.render)
      }

      render(timestamp) {
        this.frame = 0
        if (!this.enhanced || !this.near || document.hidden) return
        const rect = this.track.getBoundingClientRect()
        const stickyHeight = this.sticky.getBoundingClientRect().height || window.innerHeight
        const entry = t340Clamp01(1 - rect.top / Math.max(1, window.innerHeight))
        const scrollable = Math.max(1, rect.height - stickyHeight)
        const targetProgress = Math.max(0, Math.min(1, -rect.top / scrollable))
        const mobile = this.mobileQuery.matches
        const previousProgress = this.displayProgress
        const progress = t340SmoothProgress({
          current: this.displayProgress,
          target: targetProgress,
          deltaMs: this.lastFrameTime ? timestamp - this.lastFrameTime : T340_SMOOTHING.frameMs,
          responseMs: mobile ? 95 : 150,
          snap: this.snapNextFrame
        })
        const shouldContinue = Math.abs(targetProgress - progress) > T340_SMOOTHING.snapEpsilon
        this.displayProgress = progress
        this.lastFrameTime = shouldContinue ? timestamp : 0
        this.snapNextFrame = false
        const stage = this.stageForProgress(progress)
        const direction = Number.isFinite(previousProgress) && progress < previousProgress ? -1 : 1
        this.prepareImagesForStage(stage, direction)

        let sceneGeometryNeeded = false
        this.bgScenes.forEach((scene) => {
          const sceneIndex = Number(scene.dataset.t340lsScene)
          const motion = t340SceneMotion({ progress, stage, sceneIndex, timeline: this.timeline })
          if (motion.nearDistance <= 1.2) scene.setAttribute('data-t340ls-near', '')
          else scene.removeAttribute('data-t340ls-near')
          scene.style.setProperty('--t340ls-scene-bg-opacity', motion.opacity.toFixed(3))
          scene.style.setProperty('--t340ls-scene-bg-scale', motion.scale.toFixed(4))
          scene.style.setProperty('--t340ls-scene-bg-x', `${motion.pan.toFixed(2)}vw`)
          scene.style.setProperty('--t340ls-scene-draw', motion.draw.toFixed(3))
          scene.style.setProperty('--t340ls-scene-callout-opacity', motion.lineOpacity.toFixed(3))
          scene.style.setProperty('--t340ls-scene-info', motion.info.toFixed(3))
          scene.style.setProperty('--t340ls-scene-specs', motion.specs.toFixed(3))
          if (
            motion.nearDistance <= 1.2
            && (this.sceneDirty || !scene.hasAttribute('data-t340ls-scene-geometry-ready'))
          ) {
            sceneGeometryNeeded = true
          }
        })
        if (sceneGeometryNeeded) this.scheduleSceneGeometry()

        this.copyScenes.forEach((scene) => {
          const sceneIndex = Number(scene.dataset.t340lsCopyScene)
          const motion = t340CopyMotion({ progress, stage, sceneIndex, mobile, timeline: this.timeline, entry })
          if (motion.nearDistance <= 1.05) scene.setAttribute('data-t340ls-near', '')
          else scene.removeAttribute('data-t340ls-near')
          scene.style.setProperty('--t340ls-copy-opacity', motion.opacity.toFixed(3))
          scene.style.setProperty('--t340ls-copy-y', `${motion.offset.toFixed(2)}px`)
          scene.style.setProperty('--t340ls-copy-scale', motion.scale.toFixed(3))
        })

        if (shouldContinue) this.queue()
      }

      parseAnchor(value) {
        const [rawX, rawY] = String(value ?? '').split(',')
        const clamp = (raw) => {
          const numeric = Number(String(raw ?? '').trim())
          if (!Number.isFinite(numeric)) return 50
          return Math.max(0, Math.min(100, numeric))
        }
        return [clamp(rawX), clamp(rawY)]
      }

      scheduleSceneGeometry() {
        if (this.sceneGeometryFrame) return
        this.sceneGeometryFrame = requestAnimationFrame(() => {
          this.sceneGeometryFrame = 0
          if (!this.enhanced || !this.near) return
          const refresh = this.sceneDirty
          this.sceneDirty = false
          this.bgScenes.forEach((scene) => {
            if (!scene.hasAttribute('data-t340ls-near')) return
            if (!refresh && scene.hasAttribute('data-t340ls-scene-geometry-ready')) return
            this.updateSceneGeometry(scene)
          })
        })
      }

      updateSceneGeometry(scene) {
        const image = scene.querySelector('img')
        const svg = scene.querySelector('.t340ls__scene-callout')
        const path = svg?.querySelector('path')
        const info = scene.querySelector('.t340ls__scene-info')
        const rule = scene.querySelector('.t340ls__scene-info-rule')
        const width = this.sticky.offsetWidth
        const height = this.sticky.offsetHeight
        if (!image || !svg || !path || !info || !rule || !image.complete || !image.naturalWidth || width < 2 || height < 2) {
          scene.removeAttribute('data-t340ls-scene-geometry-ready')
          return
        }

        const coverScale = Math.max(width / image.naturalWidth, height / image.naturalHeight)
        const contentWidth = image.naturalWidth * coverScale
        const contentHeight = image.naturalHeight * coverScale
        const contentLeft = (width - contentWidth) / 2
        const contentTop = (height - contentHeight) / 2
        const mobile = this.mobileQuery.matches
        const anchorTokens = String(scene.dataset.t340lsSceneAnchor || '50,50,50,50').split(',').map((token) => token.trim())
        const forcedSide = anchorTokens[0] === 'left' || anchorTokens[0] === 'right' ? anchorTokens.shift() : null
        const [desktopX, desktopY] = this.parseAnchor(`${anchorTokens[0]},${anchorTokens[1]}`)
        const fallbackMobile = `${anchorTokens[2] ?? anchorTokens[0]},${anchorTokens[3] ?? anchorTokens[1]}`
        const [mobileX, mobileY] = this.parseAnchor(fallbackMobile)
        const blockGap = Number(anchorTokens[4])
        const anchorX = mobile ? mobileX : desktopX
        const anchorY = mobile ? mobileY : desktopY
        const dotX = contentLeft + contentWidth * anchorX / 100
        const dotY = contentTop + contentHeight * anchorY / 100
        const side = forcedSide || (anchorX > 50 ? 'left' : 'right')
        info.classList.toggle('t340ls__scene-info--right', side === 'right' && !mobile)
        svg.setAttribute('viewBox', `0 0 ${width} ${height}`)

        if (mobile) {
          info.style.removeProperty('right')
          info.style.left = '20px'
          info.style.top = 'auto'
          info.style.bottom = 'max(76px, calc(env(safe-area-inset-bottom) + 62px))'
          const blockTop = info.offsetTop
          const dropY = Math.max(dotY + 18, Math.min(blockTop, dotY + 150))
          path.setAttribute('d', `M ${dotX.toFixed(2)} ${dotY.toFixed(2)} V ${dropY.toFixed(2)}`)
        } else {
          const gap = Number.isFinite(blockGap) ? Math.max(60, Math.min(600, blockGap)) : 120
          const minEdge = 44
          const maxEdge = width - 72
          info.style.top = '0px'
          info.style.bottom = 'auto'
          const blockWidth = info.offsetWidth
          if (side === 'left') {
            let blockRight = dotX - gap
            blockRight = Math.min(blockRight, maxEdge)
            const blockLeft = Math.max(minEdge, blockRight - blockWidth)
            info.style.left = `${blockLeft.toFixed(1)}px`
            info.style.removeProperty('right')
          } else {
            let blockLeft = dotX + gap
            blockLeft = Math.max(blockLeft, minEdge)
            blockLeft = Math.min(blockLeft, maxEdge - blockWidth)
            info.style.left = `${blockLeft.toFixed(1)}px`
            info.style.removeProperty('right')
          }
          info.style.top = `${(dotY - rule.offsetTop).toFixed(1)}px`
          const farX = side === 'left'
            ? info.offsetLeft
            : info.offsetLeft + info.offsetWidth
          path.setAttribute('d', `M ${farX.toFixed(2)} ${dotY.toFixed(2)} H ${dotX.toFixed(2)}`)
        }
        const pathLength = typeof path.getTotalLength === 'function' ? path.getTotalLength() : 0
        scene.style.setProperty('--t340ls-scene-length', pathLength ? pathLength.toFixed(1) : '0')
        scene.setAttribute('data-t340ls-scene-geometry-ready', '')
      }

      releaseLayers() {
        this.copyScenes.forEach((scene) => scene.removeAttribute('data-t340ls-near'))
        this.bgScenes.forEach((scene) => scene.removeAttribute('data-t340ls-near'))
      }

    }

    customElements.define('t340-lens-scroll', T340LensScroll)
  }
  } catch(e) { console.error(e); }
})();

})();
